import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { useCollaborationSidebarActions } from '../store/collaborationSidebarProvider';
export default function useSidebarOpenCloseHandlers() {
  "use memo";

  const $ = _c(7);
  const actions = useCollaborationSidebarActions();
  let t0;
  if ($[0] !== actions) {
    t0 = () => {
      actions.openSidebar();
    };
    $[0] = actions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onOpenSidebar = t0;
  let t1;
  if ($[2] !== actions) {
    t1 = () => {
      actions.closeSidebar();
    };
    $[2] = actions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClose = t1;
  let t2;
  if ($[4] !== handleClose || $[5] !== onOpenSidebar) {
    t2 = {
      handleClose,
      onOpenSidebar
    };
    $[4] = handleClose;
    $[5] = onOpenSidebar;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}